import { PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './about-your-store.html';
import {MySiteRestService} from '@nuskin/my-site-api';
import { MySiteApp } from '../../my-site-app';
import {RunConfigService, nuskin} from '@nuskin/ns-util';

/**
 * @customElement
 * @polymer
 */
export class AboutYourStore extends PolymerElement {
    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        this.commonStrings = {}

        this.eventsToListenTo = [
            'value-changed',
            'valid-changed',
            'invalid-changed'
        ];

        this.formFields = [];
        this.storefrontData = {};

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'about-your-store';
    }

    ready() {
        super.ready();
        this.getFormFields();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.addEventListener(event, this.parentNode.formChanged);
                field.addEventListener('focused-changed', this.parentNode.formTouched);
            });
        });
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.mySite.addEventListener('common-strings-changed', this._subscribeToCommonStrings.bind(this));

        this.$.storeName.addEventListener('value-changed', this._handleStoreNameChange.bind(this));
        this.$.aboutYourStore.addEventListener('value-changed', this._handleAboutYourStoreChange.bind(this));
        this.$.purchaseMessage.addEventListener('value-changed', this._handlePurchaseMessageChange.bind(this));

        this.runConfig = RunConfigService.getRunConfig();
        this.maxChar = 500;
        this.maxCharPurchase = 250;

        this.set('commonStrings',this.mySite.commonStrings);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.removeEventListener(event, this.parentNode.formChanged);
                field.removeEventListener('focused-changed', this.parentNode.formTouched);
            });
        });

        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));

        this.$.aboutYourStore.removeEventListener('value-changed', this._handleAboutYourStoreChange.bind(this));
        this.$.purchaseMessage.removeEventListener('value-changed', this._handlePurchaseMessageChange.bind(this));

    }

    _subscribeToCommonStrings(e) {
        let data = e.detail.value
        this.set('fieldRequired', data.fieldRequired)
    }

    getFormFields() {
        this.formFields = [
            this.$.storeName,
            this.$.purchaseMessage,
            this.$.aboutYourStore
        ];
    }

    _handleStoreNameChange(e) {
        this.parentNode.updateAndNotify(e.detail.value, true, true, 'storeName');
    }

    _handleAboutYourStoreChange(e) {
        this.aboutYourStoreLength = e.target.value.length || 0;
        this.parentNode.updateAndNotify(e.detail.value, true, true, 'aboutYourStore');
    }

    _handlePurchaseMessageChange(e) {
        this.purchaseMessageLength = e.target.value.length || 0;
        this.parentNode.updateAndNotify(e.detail.value, true, true, 'purchaseMessage');
    }

    // must be present to allow `form-wrapper` save the form
    save() {
        let that = this;
        return function() {

            let data = {
                storeName: that.$.storeName.value,
                aboutYourStore: that.$.aboutYourStore.value,
                purchaseMessage: that.$.purchaseMessage.value
            };
            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: AboutYourStore.is,
                        changed: data
                    }
                });
            } catch(err) {console.log(err)}
            return MySiteRestService.updateMarketAndLanguageSpecificData(that.mySite.currentMarket, that.mySite.currentLanguage, data);
        };
    }

    _subscribeToMySiteDataChanges(){
        if(this.mySite.currentForm !== AboutYourStore.is) return;
        this.set('data', this.mySite.mySiteData);
        this.set('subdomain', Object.keys(this.data.storefront)[0]);
        this.profilePhoto = this.data.photoURL;
        this.parentNode.formChanged();
        if (this.subdomain) {
            this.storefrontSubdomain = this.subdomain;
            this.storefrontData = this.data.storefront[this.subdomain];
            let storeName = this.storefrontData[this.mySite.currentMarket].lang[this.mySite.currentLanguage].storeName;
            let aboutYourStore = this.storefrontData[this.mySite.currentMarket].lang[this.mySite.currentLanguage].aboutYourStore;
            let purchaseMessage = this.storefrontData[this.mySite.currentMarket].lang[this.mySite.currentLanguage].purchaseMessage;

            // DTS-266
            this.storeName = this.$.storeName.focused 
                ? storeName
                : storeName || this.mySite.mySiteHomeTranslations.tdc_welcomeSectionSiteName;
            this.aboutYourStore = this.$.aboutYourStore.focused 
                ? aboutYourStore
                : aboutYourStore || this.mySite.mySiteHomeTranslations.tdc_welcomeSectionAboutYourSite;
            this.purchaseMessage = this.$.purchaseMessage.focused
                ? purchaseMessage
                : purchaseMessage || this.content.aboutYourStoreFormPurchaseMessage;

            this.aboutYourStoreLength = this.aboutYourStore.length;
            this.purchaseMessageLength = this.purchaseMessage.length;
        }
    }
}

window.customElements.define(AboutYourStore.is, AboutYourStore);
